<template>
  <sweet-modal blocking :title="$t('project_tab_meetings_first_card_editTeam')" ref="lateMeetingModal" class="modal" v-on:close="closeModal">
    <el-form :rules="rules" :model="form" status-icon ref="form" class="form" size="mini">
      <el-form-item prop="teamId">
        <el-select no-data-text="no date" v-model="form.teamId" multiple :placeholder="$t('modal_team')" style="width: 100%;">
          <el-option
              v-for="item in companyUserList"
              :key="item.id"
              :label="item.user.fullName"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="modal__btn">
        <el-button @click="save('form')" type="primary">{{$t('general_submit')}}</el-button>
      </el-form-item>
    </el-form>
  </sweet-modal>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
import axios from "axios";
import moment from "moment";

export default {
name: "editTeamMeetingModal",
  components:{
    SweetModal,
  },
  props: {
    meetingType: {
      type: Number,
      default: 1
    },
    page: {
      type: Number,
      default: 1
    }
  },
  data(){
    return {
      companyUserList: [],
      state: null,
      meeting: null,
      form: {
        hostId: null,
        teamId: []
      },
      rules: {
        teamId: [{
          required: true,
          message: this.$i18n.t('modal_settings_fieldIsRequired'),
          trigger: 'blur'
        }],
      }
    }
  },
  methods:{
    openModal(meeting, state){
      this.meeting = meeting
      this.state = state
      let url = `/api/v1/meetings/directories?companyId=${this.$route.query.companyId}&parentId=${this.$route.query.projectId || this.$route.query.businessUnitId || this.$route.query.engagementId}&operation=update&taskId=${this.meeting.taskId}&typeId=${this.meetingType}`;
      // switch (this.state) {
      //   case 'projectMeetings':
      //     url = `/api/v1/meetings/directories?companyId=${this.$route.query.companyId}&parentId=${this.$route.query.projectId}&operation=update&taskId=null&typeId=${this.meetingType}`
      //     break;
      //   case 'businessUnitMeetings.vue':
      //     url = `/api/v1/businessUnitMeetings/directories?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&operation=update`
      //     break;
      //   case 'engagementMeetings.vue':
      //     url = `/api/v1/engagementMeetings/directories?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&operation=update`
      //     break;
      //   case 'projectTaskMeetings':
      //     url = `/api/v1/projectTaskMeetings/directories?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectTaskId=${this.meeting.projectTaskId}&operation=update`
      //     break;
      //   case 'businessUnitTaskMeetings.vue':
      //     url = `/api/v1/businessUnitTaskMeetings/directories?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&businessUnitTaskId=${this.meeting.businessUnitTaskId}&operation=update`
      //     break;
      //   case 'engagementTaskMeetings.vue':
      //     url = `/api/v1/engagementTaskMeetings/directories?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.meeting.engagementTaskId}&operation=update`
      //     break;
      // }
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(url)
          .then(response => {
            this.companyUserList = response.data.companyUserList.sort(this.compare)
            this.getItemMeeting(this.meeting.id)
            this.$refs.lateMeetingModal.open();
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          })

    },
    getItemMeeting(meetingId){
      let loader = this.$loading.show();
      let url = `/api/v1/meetings/item?companyId=${this.$route.query.companyId}&parentId=${this.$route.query.projectId || this.$route.query.businessUnitId || this.$route.query.engagementId}&meetingId=${meetingId}&taskId=${this.meeting.taskId}&typeId=${this.meetingType}`
      // switch (this.state) {
      //   case 'projectMeetings':
      //     url = `/api/v1/meetings/item?companyId=${this.$route.query.companyId}&parentId=${this.$route.query.projectId}&meetingId=${meetingId}&taskId=null&typeId=${this.meetingType}`
      //     break;
      //   case 'businessUnitMeetings.vue':
      //     url = `/api/v1/businessUnitMeetings/item?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&businessUnitMeetingId=${meetingId}`
      //     break;
      //   case 'engagementMeetings.vue':
      //     url = `/api/v1/engagementMeetings/item?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementMeetingId=${meetingId}`
      //     break;
      //   case 'projectTaskMeetings':
      //     url = `/api/v1/projectTaskMeetings/item?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectTaskId=${this.meeting.projectTaskId}&projectTaskMeetingId=${meetingId}`
      //     break;
      //   case 'businessUnitTaskMeetings.vue':
      //     url = `/api/v1/businessUnitTaskMeetings/item?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&businessUnitTaskId=${this.meeting.businessUnitTaskId}&businessUnitTaskMeetingId=${meetingId}`
      //     break;
      //   case 'engagementTaskMeetings.vue':
      //     url = `/api/v1/engagementTaskMeetings/item?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.meeting.engagementTaskId}&engagementTaskMeetingId=${meetingId}`
      //     break;
      // }
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(url)
          .then(response => {
            this.form.hostId = response.data.item.hostId
            this.form.teamId = response.data.item.companyUserIdList.filter(val => val !== response.data.item.hostId)
            this.companyUserList = this.companyUserList.filter(val => val.id !== response.data.item.hostId)
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          })
    },
    save(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          // put host into the team
          this.form.teamId.push(this.form.hostId)
          let url = `/api/v1/meetings/updateTeam?companyId=${this.$route.query.companyId}&parentId=${this.$route.query.projectId || this.$route.query.businessUnitId || this.$route.query.engagementId}&meetingId=${this.meeting.id}&taskId=${this.meeting.taskId}&typeId=${this.meetingType}`;
          // switch (this.state) {
          //   case 'projectMeetings':
          //     url = `/api/v1/meetings/updateTeam?companyId=${this.$route.query.companyId}&parentId=${this.$route.query.projectId}&meetingId=${this.meeting.id}&taskId=null&typeId=${this.meetingType}`
          //     break;
          //   case 'businessUnitMeetings':
          //     url = `/api/v1/businessUnitMeetings/updateTeam?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&businessUnitMeetingId=${this.meeting.id}`
          //     break;
          //   case 'engagementMeetings':
          //     url = `/api/v1/engagementMeetings/updateTeam?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementMeetingId=${this.meeting.id}`
          //     break;
          //   case 'projectTaskMeetings':
          //     url = `/api/v1/projectTaskMeetings/updateTeam?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectTaskId=${this.meeting.projectTaskId}&projectTaskMeetingId=${this.meeting.id}`
          //     break;
          //   case 'businessUnitTaskMeetings':
          //     url = `/api/v1/businessUnitTaskMeetings/updateTeam?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&businessUnitTaskId=${this.meeting.businessUnitTaskId}&businessUnitTaskMeetingId=${this.meeting.id}`
          //     break;
          //   case 'engagementTaskMeetings':
          //     url = `/api/v1/engagementTaskMeetings/updateTeam?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.meeting.engagementTaskId}&engagementTaskMeetingId=${this.meeting.id}`
          //     break;
          // }
          const data = {
            companyUserIdList: this.form.teamId
          }
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(url, data)
            .then(response => {
              loader.hide()
              this.$store.dispatch('getMeetings', {
                companyId: this.$route.query.companyId,
                parentId: this.$route.query.projectId || this.$route.query.businessUnitId || this.$route.query.engagementId,
                taskId: this.meeting.taskId,
                typeId: this.meetingType,
                page: this.page
              })
              // switch (this.state) {
              //   case 'projectMeetings':
              //     this.$store.dispatch('getProjectMeetings')
              //     break;
              //   case 'businessUnitMeetings':
              //     this.$store.dispatch('getBusinessUnitMeetings')
              //     break;
              //   case 'engagementMeetings':
              //     this.$store.dispatch('getEngagementMeetings')
              //     break;
              //   case 'projectTaskMeetings':
              //     this.$store.dispatch('getProjectTaskMeetings', { taskId: this.meeting.projectTaskId} )
              //     break;
              //   case 'businessUnitTaskMeetings':
              //     this.$store.dispatch('getBusinessUnitTaskMeetings', this.meeting.businessUnitTaskId)
              //     break;
              //   case 'engagementTaskMeetings':
              //     this.$store.dispatch('getEngagementTaskMeetings', this.meeting.engagementTaskId)
              //     break;
              // }
              this.notification(this.$t('general_success'), this.$t('notification_updateMeeting'), "success");
              this.$refs.lateMeetingModal.close()
            })
            .catch(err => {
              loader.hide()
              console.log(err)
          })

        }
      })
    },
    closeModal(){
      this.state = null
      this.form.hostId = null
      this.form.teamId = [];
      this.companyUserList = [];
      this.meeting = null;
      this.$refs['form'].resetFields();
    },
    compare( a, b ) {
      if ( a.user.firstname < b.user.firstname ){
        return -1;
      }
      if ( a.user.firstname > b.user.firstname){
        return 1;
      }
      return 0;
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    }
  }
}
</script>

<style scoped>

</style>
